import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './OptionList.scss'
import { Option, DisplayText, ErrorText } from './../../index'
import * as ts from '../../../services/translationService'

export default function OptionList({
  title,
  allowMultiple,
  options,
  selected,
  onChange = () => {},
  error,
  name,
  optional = false,
}) {
  const finalName = allowMultiple ? `${name}[]` : name

  const className = classNames(styles.OptionList)

  const titleMarkup = title ? (
    <DisplayText size="extraSmall" className={styles.Title}>
      {title} {optional && <small>{ts.t('system.optional')}</small>}
    </DisplayText>
  ) : null

  const optionsMarkup = options.map(option => {
    const { value, label } = option

    function handleChange(event) {
      onChange(updateSelectedOptions(option, event, selected, allowMultiple), name)
    }

    const isSelected = optionIsSelected(option, selected)
    const children = option.renderChildren ? (
      <div className={styles.ChoiceChildren}>{option.renderChildren(isSelected)}</div>
    ) : null

    return (
      <li key={value} className={styles.Option}>
        <Option
          label={label}
          type={allowMultiple ? 'checkbox' : 'radio'}
          name={finalName}
          value={value}
          hasError={!!error}
          checked={optionIsSelected(option, selected, allowMultiple)}
          onChange={handleChange}
        />
        {children}
      </li>
    )
  })

  const errorMarkup = error && <ErrorText className={styles.Error} transKey={error} />

  return (
    <div className={className}>
      {titleMarkup}
      <ul className={styles.Options}>{optionsMarkup}</ul>
      {errorMarkup}
    </div>
  )
}

function optionIsSelected({ value }, selected, allowMultiple = false) {
  return allowMultiple ? selected.indexOf(value) >= 0 : selected == value
}

function updateSelectedOptions({ value }, checked, selected, allowMultiple = false) {
  if (checked) {
    return allowMultiple ? [...selected, value] : value
  }
  return selected.filter(selectedChoice => selectedChoice !== value)
}

OptionList.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  allowMultiple: PropTypes.bool,
  options: PropTypes.any,
  selected: PropTypes.any,
  onChange: PropTypes.func,
  error: PropTypes.string,
  name: PropTypes.string,
  optional: PropTypes.bool,
}



// WEBPACK FOOTER //
// ./src/components/Form/OptionList/OptionList.js